import TableConfigFiles from '../../../components/table/files/TableConfigFiles'

const EditDocument = () => {
  return <TableConfigFiles />
}

export default EditDocument
